// Import and register all your controllers here (esbuild — no importmap).
// As you add controllers in later phases, import and register them below.
import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import SiteStatusController from "./site_status_controller"
application.register("site-status", SiteStatusController)

import CrawlLogController from "./crawl_log_controller"
application.register("crawl-log", CrawlLogController)

import EmbedCodeController from "./embed_code_controller"
application.register("embed-code", EmbedCodeController)

import WidgetPreviewController from "./widget_preview_controller"
application.register("widget-preview", WidgetPreviewController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import BillingIntervalController from "./billing_interval_controller"
application.register("billing-interval", BillingIntervalController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import WidgetModeController from "./widget_mode_controller"
application.register("widget-mode", WidgetModeController)

import ToggleElementController from "./toggle_element_controller"
application.register("toggle-element", ToggleElementController)

import ReindexController from "./reindex_controller"
application.register("reindex", ReindexController)

import AnalyticsEventsController from "./analytics_events_controller"
application.register("analytics-events", AnalyticsEventsController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)
